import { useMemo } from 'react'

/**
 * Promise Wrapper for React Suspense
 *
 * @param _promise
 * @returns {{read: (function(): *)}}
 */
const wrapPromise = (_promise) => {
  const promise = _promise(null)

  let status = 'pending'
  let response

  const suspender = promise.then(
    (res) => {
      status = 'success'
      response = res
    },
    (err) => {
      status = 'error'
      response = err
    },
  )

  const read = () => {
    switch (status) {
      case 'pending':
        throw suspender
      case 'error':
        throw response
      default:
        return response
    }
  }

  return { read }
}

const usePromise = fn => useMemo(() => wrapPromise(fn), [fn])

export default usePromise
